module.exports = __webpack_public_path__ + "static/1286721496.5af9b6f1.jpg";